<template>
    <router-link v-if="imgsrc" :to="link ? link : '/'" class="logo block">
        <img :src="imgsrc" alt="Logo">
    </router-link>
</template>

<script>
    export default {
        name: "Logo",
        props: ['imgsrc', 'link']
    }
</script>

<style scoped>

</style>